module.exports = __webpack_public_path__ + "resources/food-9a10a76c7a181750e123d755b31e0833.svg";